import { createReducer } from '@reduxjs/toolkit'

import { adGroupsSummaryTableColumnsConfig } from 'configuration/tables/adGroupTable'
import {
    AD_GROUP_STATES,
    AD_GROUPS,
    CAMPAIGN_STATES,
    CAMPAIGNS,
    COUNTRIES,
    DATES,
    FACT_TYPES,
    LABELS,
    METRIC_FILTERS,
} from 'const/filters'
import { FILTER_SETTINGS, FILTERS } from 'const/reducerKeys'
import {
    CAMPAIGN_STATES as CAMPAIGN_STATES_OPTIONS,
    ENABLED,
    STATE_FIELD_OPTIONS,
} from 'const/resourceStates'
import { serializeColumns } from 'helpers/tables'
import { defaultPage, getDefaultTable } from 'reducers/ui/defaults'

const initialState = {
    ...defaultPage,
    [FILTERS]: {
        [METRIC_FILTERS]: [],
        [FACT_TYPES]: [],
        [COUNTRIES]: [],
        [CAMPAIGNS]: [],
        [CAMPAIGN_STATES]: [
            {
                value: ENABLED,
                label: CAMPAIGN_STATES_OPTIONS[ENABLED],
            },
        ],
        [LABELS]: [],
        [AD_GROUPS]: [],
        [AD_GROUP_STATES]: [
            {
                value: ENABLED,
                label: STATE_FIELD_OPTIONS[ENABLED],
            },
        ],
    },
    [FILTER_SETTINGS]: {
        anchored: [DATES],
        order: [
            AD_GROUPS,
            AD_GROUP_STATES,
            CAMPAIGNS,
            CAMPAIGN_STATES,
            FACT_TYPES,
            COUNTRIES,
            LABELS,
            METRIC_FILTERS,
        ],
        displayState: {
            [AD_GROUPS]: true,
            [AD_GROUP_STATES]: true,
            [CAMPAIGNS]: true,
            [CAMPAIGN_STATES]: true,
            [FACT_TYPES]: true,
            [COUNTRIES]: true,
            [LABELS]: true,
            [METRIC_FILTERS]: true,
        },
        userAdded: [AD_GROUP_STATES, CAMPAIGN_STATES],
    },
    table: getDefaultTable(
        serializeColumns(adGroupsSummaryTableColumnsConfig),
        {
            showTotalRow: true,
        }
    ),
}

export default createReducer(initialState, () => {})
